<template>
  <v-dialog v-model="localDialog" width="95%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Company' : 'Update Company' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="CompnaySetup">
              <v-row>
                  <v-col lg="4" md="4" cols="12">    
                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="name.value.value"
                          :error-messages="name.errorMessage.value"
                          clearable
                      > 
                        <template #label>
                          Name <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="company_owner_name.value.value"
                          :error-messages="company_owner_name.errorMessage.value"
                          clearable
                      > 
                        <template #label>
                          Company Owner Name
                        </template>
                      </v-text-field>

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="mobile.value.value"
                          :error-messages="mobile.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Mobile <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                          label="Tagline (Optional)"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="tagline.value.value"
                          :error-messages="tagline.errorMessage.value"
                          clearable
                      ></v-text-field>

                      <v-text-field
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="email.value.value"
                          :error-messages="email.errorMessage.value"
                          clearable
                      >
                        <template #label>
                          Email <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                    <!-- Header Image -->
                    <v-file-input
                        v-model="selectedHeaderImage"
                        label="Company Header Image"
                        accept="image/*"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        show-size
                        @input="previewHeaderImage"
                        @click:clear="clearHeaderImage"
                        class="ellipsis-filename mt-2"
                        title="Header Image"
                    >                                                                                                  
                    </v-file-input>
                    <div style="margin-top: 10px; text-align: center;">
                        <v-img :src="previewHeader" cover class="preview-image" style="max-width: 100%; max-height: 150px; margin: 0 auto;"></v-img>
                    </div>
                                           
                  </v-col>

                  <v-col lg="4" md="4" cols="12"> 
                      <v-text-field
                          label="Website (Optional)"
                          density="compact"
                          single-line
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="website.value.value"
                          :error-messages="website.errorMessage.value"
                          clearable
                      ></v-text-field>

                        <v-autocomplete
                            density="compact"
                            variant="outlined"
                            bg-color="grey-lighten-4"
                            v-model="owner_designation_id.value.value"
                            :error-messages="owner_designation_id.errorMessage.value"
                            clearable
                            :items="getHrmDesignationList"
                            :item-title="item => `${item.name}-${item.code}`"   
                            autocomplete="off"                                               
                            item-value="id"
                            :loading="employeeLoading"
                            
                            :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                <template #label>
                                    Owner Designation
                                </template> 
                            </v-autocomplete>
                      <v-text-field
                          label="TIN Number (Optional)"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="tin_no.value.value"
                          :error-messages="tin_no.errorMessage.value"
                          clearable
                      ></v-text-field>
                      
                      <v-text-field
                          label="BIN Number (Optional)"
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="bin_no.value.value"
                          :error-messages="bin_no.errorMessage.value"
                          clearable
                      ></v-text-field>

                      <v-textarea
                          density="compact"
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          v-model="address.value.value"
                          :error-messages="address.errorMessage.value"
                          clearable
                          auto-grow
                          rows="1"
                      >
                        <template #label>
                          Address <span class="text-red-accent-4">*</span>
                        </template>
                      </v-textarea>

                      <!-- Footer Image -->
                      <v-file-input
                          v-model="selectedFooterImage"
                          label="Company Footer Image"
                          accept="image/*"
                          density="compact"
                          single-line
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          show-size
                          @input="previewFooterImage"
                          @click:clear="clearFooterImage"
                          class="ellipsis-filename mt-2"
                          title="Footer Image"
                      >                                                                                                  
                      </v-file-input>
                      <div style="margin-top: 10px; text-align: center;">
                          <v-img :src="previewFooter" cover class="preview-image" style="max-width: 100%; max-height: 150px; margin: 0 auto;"></v-img>
                      </div>
                  </v-col>

                  <v-col lg="4" md="4" cols="12">                                
                      
                    <v-file-input
                        v-model="selectedFavicon"
                        label="Company favicon"
                        accept="image/*"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"                    
                        @click:clear="clearFavicon"
                        class="ellipsis-filename"
                        title="Favicon"
                    >                                                                                                  
                    </v-file-input>


                    <v-file-input
                        v-model="selectedImage"
                        label="Company logo"
                        accept="image/*"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        show-size
                        @input="previewImage"                               
                        @click:clear="clearImage"
                        class="ellipsis-filename"
                        title="image"
                    >                                                                                                  
                    </v-file-input>

                    <div style="float: right;">
                        <v-img  :src="preview" cover  class="preview-image"></v-img>
                    </div>

                      <v-checkbox                            
                          label="Group Head"
                          v-model="group_head_ind.value.value"
                          :error-messages="group_head_ind.errorMessage.value"
                          density="compact"
                          variant="outlined"
                          hide-details
                          single-line
                          color="success"
                          value="1"
                      ></v-checkbox>

                      <v-checkbox                            
                          label="Active"
                          v-model="status.value.value"
                          :error-messages="status.errorMessage.value"
                          density="compact"
                          variant="outlined"
                          hide-details
                          single-line
                          color="primary"
                          value="1"
                      ></v-checkbox>
                      <input v-model="company_id.value.value" type="hidden">


                        <v-file-input
                          v-model="selectedWatermark"
                          label="Watermark"
                          accept="image/*"
                          density="compact"
                          single-line
                          variant="outlined"
                          bg-color="grey-lighten-4"
                          show-size
                          @input="previewWatermarkImage"
                          @click:clear="clearWatermark"
                          class="ellipsis-filename mt-15"
                          title="Watermark"
                      >                                                                                                  
                      </v-file-input>
                      <div style="margin-top: 10px; text-align: center;">
                          <v-img :src="previewWatermark" cover class="preview-image" style="max-width: 100%; max-height: 150px; margin: 0 auto;"></v-img>
                      </div>

                  </v-col>
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import { fileServerUrl } from "@/store/api";

export default {
  name: 'CompanySetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        name: '',
        tagline: '',
        email: '',
        mobile: '',
        website: '',
        tin_no: '',
        bin_no: '',
        address: '',
        group_head_ind: '0',
        status: 1,
        company_id: null,
      })
    }
  },
  data() {
      return {
    employeeLoading: false,
      localDialog: this.dialog,
      selectedImage: null,
      errorMessages: '',
      preview: '/src/assets/no_preview.jpeg',
      previewHeader: '/src/assets/no_preview.jpeg',
      previewFooter: '/src/assets/no_preview.jpeg',
      previewWatermark: '/src/assets/no_preview.jpeg',
      loading: false,
      selectedFavicon: null,
      selectedHeaderImage: null,
      selectedFooterImage: null,
      selectedWatermark: null,
      isEntryMode: true,
    }
  },
computed: {
    getHrmDesignationList() {
        return this.$store.getters.getHrmDesignationList;
    }
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.name.setValue(newData.name || '', false);
        this.company_owner_name.setValue(newData.company_owner_name || '', false);
        this.owner_designation_id.setValue(newData.owner_designation_id || null, false);
        this.tagline.setValue(newData.tagline || '', false);
        this.email.setValue(newData.email || '', false);
        this.mobile.setValue(newData.mobile || '', false);
        this.website.setValue(newData.website || '', false);
        this.tin_no.setValue(newData.tin_no || '', false);
        this.bin_no.setValue(newData.bin_no || '', false);
        this.address.setValue(newData.address || '', false);
        this.group_head_ind.setValue(String(newData.group_head_ind) || '0', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.company_id.setValue(newData.id || '', false);
        this.preview = newData.logo ? fileServerUrl + newData.logo : '/src/assets/no_preview.png';
        this.previewHeader = newData.header_image ? fileServerUrl + newData.header_image : '/src/assets/no_preview.png';
        this.previewFooter = newData.footer_image ? fileServerUrl + newData.footer_image : '/src/assets/no_preview.png';
        this.previewWatermark = newData.watermark ? fileServerUrl + newData.watermark: '/src/assets/no_preview.png';
      },
    }
    
  },
    created() {
    // if(this.$store.getters.getHrmDesignationList.length === 0) {
            this.employeeLoading = true;
            this.$store.dispatch("getHrmDesignationList").then((response) => {
                this.employeeLoading = false;
            })
        // }
  },
  methods: {
    previewImage: function(event) {
        this.selectedImage = event.target.files[0];
        const input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.preview = e.target.result;
            }
            this.image = input.files[0];
            reader.readAsDataURL(input.files[0]);
        }
        else {
            this.preview = '/src/assets/no_preview.jpeg';
        }
    },
    clearImage() {
        this.preview = '/src/assets/no_preview.jpeg';
    },
    clearFavicon() {
        this.selectedFavicon = null;
    },
    previewHeaderImage: function(event) {
        // v-file-input may pass file array or event
        let file = null;
        if (event && Array.isArray(event) && event.length > 0) {
            file = event[0];
        } else if (event && event.target && event.target.files && event.target.files[0]) {
            file = event.target.files[0];
        } else if (event instanceof File) {
            file = event;
        }
        
        if (file) {
            this.previewHeaderFromFile(file);
        } else {
            this.previewHeader = '/src/assets/no_preview.jpeg';
        }
    },
    previewHeaderFromFile(file) {
        if (file) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.previewHeader = e.target.result;
            }
            reader.readAsDataURL(file);
        }
    },
    clearHeaderImage() {
        this.previewHeader = '/src/assets/no_preview.jpeg';
        this.selectedHeaderImage = null;
    },
    previewFooterImage: function(event) {
        // v-file-input may pass file array or event
        let file = null;
        if (event && Array.isArray(event) && event.length > 0) {
            file = event[0];
        } else if (event && event.target && event.target.files && event.target.files[0]) {
            file = event.target.files[0];
        } else if (event instanceof File) {
            file = event;
        }
        
        if (file) {
            this.previewFooterFromFile(file);
        } else {
            this.previewFooter = '/src/assets/no_preview.jpeg';
        }
    },
    previewFooterFromFile(file) {
        if (file) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.previewFooter = e.target.result;
            }
            reader.readAsDataURL(file);
        }
    },
    clearFooterImage() {
        this.previewFooter = '/src/assets/no_preview.jpeg';
        this.selectedFooterImage = null;
    },
    previewWatermarkImage: function(event) {
        // v-file-input may pass file array or event
        let file = null;
        if (event && Array.isArray(event) && event.length > 0) {
            file = event[0];
        } else if (event && event.target && event.target.files && event.target.files[0]) {
            file = event.target.files[0];
        } else if (event instanceof File) {
            file = event;
        }
        
        if (file) {
            this.previewWatermarkFromFile(file);
        } else {
            this.previewWatermark = '/src/assets/no_preview.jpeg';
        }
    },
    previewWatermarkFromFile(file) {
        if (file) {
            var reader = new FileReader();
            reader.onload = (e) => {
              this.previewWatermark = e.target.result;
            }
            reader.readAsDataURL(file);
        }
    },
    clearWatermark() {
        this.previewWatermark = '/src/assets/no_preview.jpeg';
        this.selectedWatermark = null;
    },
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          name: yup.string().min(1).max(50).required().trim().label('Name'),
          company_owner_name: yup.string().max(50).trim().label('Company Owner Name'),
          //owner_designation_id: yup.string().label('Owner Designation'),
          tagline: yup.string().max(50).nullable().trim().label('Tagline'),
          email: yup.string().email().required().trim().label('Email'),
          mobile: yup.string().min(7).max(15).required("Mobile Number is required").label('Mobile'),
          website: yup.string().url().nullable().trim().max(60).label('Website'),
          tin_no: yup.string().max(50).nullable().trim().label('TIN Number'),
          bin_no: yup.string().nullable().trim().label('BIN Number'),
          address: yup.string().min(5).max(150).required().trim().label('Address'),
      }),

    });

    const name = useField('name');
    const company_owner_name = useField('company_owner_name');
    const owner_designation_id = useField('owner_designation_id');
    const tagline = useField('tagline');
    const mobile = useField('mobile');
    const email = useField('email');
    const website = useField('website');
    const tin_no = useField('tin_no');
    const bin_no = useField('bin_no');
    const address = useField('address');
    const group_head_ind = useField('group_head_ind');
    const status = useField('status');
    const company_id = useField('company_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const selectedImage  = ref(null);
    const selectedFavicon = ref(null);
    const selectedHeaderImage = ref(null);
    const selectedFooterImage = ref(null);
    const selectedWatermark = ref(null);
    const previewHeader = ref('/src/assets/no_preview.jpeg');
    const previewFooter = ref('/src/assets/no_preview.jpeg');
    const previewWatermark = ref('/src/assets/no_preview.jpeg');
    const store = useStore();

    const submit = handleSubmit((values) => {
          // Create a FormData object
          const formData = new FormData();

          // Append all form values to FormData
          Object.keys(values).forEach((key) => {
              formData.append(key, values[key]);
          });

          // Append the selected image to FormData
          if (selectedImage.value) {
              formData.append('logo', selectedImage.value); // 'logo' is the key for the file
          }
          if (selectedFavicon.value) {
              formData.append('favicon', selectedFavicon.value); // 'favicon' is the key for the file
          }
          if (selectedHeaderImage.value) {
              formData.append('header_image', selectedHeaderImage.value); // 'header_image' is the key for the file
          }
          if (selectedFooterImage.value) {
              formData.append('footer_image', selectedFooterImage.value); // 'footer_image' is the key for the file
          }
        if (selectedWatermark.value) {
              formData.append('watermark', selectedWatermark.value); // 'watermark' is the key for the file
          }

        store.dispatch("saveUpdateCompany", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getCompanyList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);   
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
        submit,
        name,
        company_owner_name,
        owner_designation_id,
        tagline,  
        mobile,
        email,
        website,
        tin_no,
        bin_no,
        address,
        group_head_ind,
        status,
        errorMessages,
        company_id,
        selectedImage,
        selectedFavicon,
        selectedHeaderImage,
        selectedFooterImage,
        selectedWatermark,
        previewHeader,
        previewFooter,
        previewWatermark,
        resetForm,
        loading
    }
  },
  mounted() {
  }
}
</script>

